import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { SchoolSearchBox } from './SchoolSearchBox.js';
import { SchoolSearchDetails } from './SchoolSearchDetails.js';
import { WithLocation } from './WithLocation.js';
import { LoadingEllipsis } from './LoadingEllipsis.js';
import { addCommas } from '../../require/utils/numberUtils.ts';

export const SchoolSearch = createReactClass({
    propTypes: {
        location: PropTypes.object,
        isTeacherRegistrationRequest: PropTypes.bool,
        userFullName: PropTypes.string,
        userEmail: PropTypes.string,
        setLocation: PropTypes.func.isRequired,
        setSelectedSchool: PropTypes.func.isRequired,
        clearSelectedSchool: PropTypes.func.isRequired,
        excludeTestRecords: PropTypes.bool,

        onSchoolSearchFocus: PropTypes.func,
        overrideShowNewSchoolRequestForm: PropTypes.func,
    },

    defaultProps: {
        excludeTestRecords: true,
    },

    getInitialState() {
        var showZipCodeSearch = !this.props.location;
        return {
            location: this.props.location,
            schoolDetails: null,
            showSchoolSearchNote: false,
            showNewSchoolRequestForm: false,
            confirmedShowNewSchoolRequestForm: false,
            showUpdateSchoolInfoForm: false,
            loadingLocation: false,
            loadingSchoolDetails: false,
            showZipCodeSearch: showZipCodeSearch,
            numTotalTeachers: null,
        };
    },

    componentDidMount() {
        this.getNumTotalTeachers();
    },

    setloadingLocation(loadingLocation) {
        this.setState((prevState) => {
            return { loadingLocation: loadingLocation };
        });
    },

    setloadingSchoolDetails(loadingSchoolDetails) {
        this.setState((prevState) => {
            return { loadingSchoolDetails: loadingSchoolDetails };
        });
    },

    getNumTotalTeachers() {
        var component = this;
        $.getJSON(baseCacheURL + 'about/impact.json', function (data) {
            component.setNumTotalTeachers(addCommas(jQuery.parseJSON(data.stats.teachersProjectsFunded)));
        });
    },

    setNumTotalTeachers(numTotalTeachers) {
        this.setState((prevState) => {
            return { numTotalTeachers: numTotalTeachers };
        });
    },

    getSchoolDetails(schoolId) {
        this.setloadingSchoolDetails(true);
        $.ajax({
            url: '/school/school_details.html',
            data: { schoolId: schoolId },
            dataType: 'json',
        }).done((data) => {
            this.setSchoolDetails(data);
        }).fail(() => {
            this.clearSelectedSchool();
            alert('There was an error retrieving the school. Please try again.');
        }).always(() => this.setloadingSchoolDetails(false));
    },

    setSchoolDetails(schoolDetails) {
        this.setState((prevState) => {
            return { schoolDetails: schoolDetails };
        });
    },

    clearSchoolDetails() {
        this.setSchoolDetails(null);
    },

    clearSelectedSchool() {
        this.props.clearSelectedSchool();
        this.clearSchoolDetails();
    },

    searchZipCode(zipCode, searchZipCodeDone) {
        this.setloadingLocation(true);
        $.ajax({
            url: '/common/zipLookup.html?zip=' + zipCode + '&APIKey=' + dcAPIKey,
            dataType: 'json',
        }).done((data) => {
            if (data) {
                this.setLocation({
                    zip: data.zip,
                    cityName: data.city,
                    stateCode: data.state,
                    latLng: { lat: data.latitude, lng: data.longitude },
                });
            } else {
                alert('There was an error retrieving this location. Please try again.');
                this.setloadingLocation(false);
            }
            if (typeof searchZipCodeDone === 'function') {
                searchZipCodeDone();
            }
        }).fail(() => {
            alert('There was an error retrieving this location. Please try again.');
            this.setloadingLocation(false);
        }).always(() => this.setShowZipCodeSearch(false));
    },

    setLocation(location) {
        this.props.setLocation(location);
        this.setloadingLocation(false);
        if (location) {
            this.setShowZipCodeSearch(false);
        }
    },

    setShowZipCodeSearch(showZipCodeSearch) {
        this.setState((prevState) => {
            return { showZipCodeSearch: showZipCodeSearch };
        });
    },

    setShowSchoolSearchNote(showSchoolSearchNote) {
        this.setState((prevState) => {
            return {
                showSchoolSearchNote: showSchoolSearchNote,
            };
        });
    },

    setShowNewSchoolRequestForm(showNewSchoolRequestForm) {
        if (this.props.setShowNewSchoolRequestForm) {
            this.props.setShowNewSchoolRequestForm();
        } else {
            this.setState((prevState) => {
                return {
                    showNewSchoolRequestForm: showNewSchoolRequestForm,
                };
            });
        }
    },

    setConfirmedShowNewSchoolRequestForm(confirmedShowNewSchoolRequestForm) {
        this.setState((prevState) => {
            return {
                confirmedShowNewSchoolRequestForm: confirmedShowNewSchoolRequestForm,
            };
        });
    },

    render() {
        if (this.state.loadingSchoolDetails) {
            return (
                <div className="input-holder">
                    <LoadingEllipsis />
                </div>
            );
        } else if (this.state.schoolDetails) {
            return (
                <div className="input-holder">
                    <SchoolSearchDetails
                        location={this.props.location}
                        isTeacherRegistrationRequest={this.props.isTeacherRegistrationRequest}
                        userFullName={this.props.userFullName}
                        userEmail={this.props.userEmail}
                        schoolDetails={this.state.schoolDetails}
                        numTotalTeachers={this.state.numTotalTeachers}
                        showUpdateSchoolInfoForm={this.state.showUpdateSchoolInfoForm}
                        setShowUpdateSchoolInfoForm={this.setShowUpdateSchoolInfoForm}
                        clearSelectedSchool={this.clearSelectedSchool}
                    />
                </div>
            );
        }

        const coreSchoolSearchBox = (
            <SchoolSearchBox
                location={this.props.location}
                isTeacherRegistrationRequest={this.props.isTeacherRegistrationRequest}
                userFullName={this.props.userFullName}
                userEmail={this.props.userEmail}
                showZipCodeSearch={this.state.showZipCodeSearch}
                showSchoolSearchNote={this.state.showSchoolSearchNote}
                showNewSchoolRequestForm={this.state.showNewSchoolRequestForm}
                loadingLocation={this.state.loadingLocation}
                confirmedShowNewSchoolRequestForm={this.state.confirmedShowNewSchoolRequestForm}
                getSchoolDetails={this.getSchoolDetails}
                setShowZipCodeSearch={this.setShowZipCodeSearch}
                searchZipCode={this.searchZipCode}
                setShowSchoolSearchNote={this.setShowSchoolSearchNote}
                setShowNewSchoolRequestForm={this.setShowNewSchoolRequestForm}
                setSelectedSchool={this.props.setSelectedSchool}
                setConfirmedShowNewSchoolRequestForm={this.setConfirmedShowNewSchoolRequestForm}
                onSchoolSearchFocus={this.props.onSchoolSearchFocus}
                setLocation={this.setLocation}
                excludeTestRecords={this.props.excludeTestRecords}
            />
        );

        if (!this.props.location) {
            return (
                <div className="input-holder">
                    <WithLocation location={this.props.location} setLocation={this.setLocation}>
                        {coreSchoolSearchBox}
                    </WithLocation>
                </div>
            );
        } else {
            return (
                <div className="input-holder">
                    {coreSchoolSearchBox}
                </div>
            );
        }
    },

    setShowUpdateSchoolInfoForm(showUpdateSchoolInfoForm) {
        this.setState((prevState) => {
            return {
                showUpdateSchoolInfoForm: showUpdateSchoolInfoForm,
            };
        });
    },
});
